export const TEMPLATE_URL = 'https://ct-aws-connect-exporter-docs.s3.us-east-1.amazonaws.com/Presidio+Amazon+Connect+Export+Template+v2.1.xlsx';

export const SHEET_NAMES = {
  HOURS_OF_OPERATION: 'Hours of Operation',
  DIALED_NUMBER_MAPPINGS: 'Dialed Number Mappings',
  AGENT_STATUS: 'Agent Status',
  QUEUES: 'Queues',
  QUICK_CONNECTS: 'Quick Connects',
  ROUTING_PROFILES: 'Routing Profiles',
  USER_HIERARCHIES: 'User Hierarchies',
  USERS: 'Users',
  SECURITY_PROFILES: 'Security Profiles',
  LAMBDA_FUNCTIONS: 'AWS Lambda Function List',
  LEX_BOTS_V2: 'Amazon Lex',
  LEX_INTENTS: 'Lex Bot Intents',
  LEX_SLOTS_AND_TYPES: 'Lex Bot Slots & Types',
  CONNECT_LAMBDA: 'AWS Lambda',
  CONTACT_FLOWS: 'Contact Flow List',
  INSTANCE_CONFIG: 'Instance',
  TRUSTED_ADVISOR: 'Trusted Advisor',
};

export const COLUMN_MAPPINGS = {
  HOURS_OF_OPERATION: {
    NAME: 'A',
    DESCRIPTION: 'B', 
    HOURS_OF_OPERATION: 'C',
    TIME_ZONE: 'D'
  },
  DIALED_NUMBER_MAPPINGS: {
    PHONE_NUMBER: 'A',
    FORWARDED_FROM: 'B',
    DESCRIPTION: 'C',
    FLOW_NAME: 'D'
  },
  AGENT_STATUS: {
    NAME: 'A',
    DESCRIPTION: 'B'
  },
  QUEUES: {
    NAME: 'A',
    DESCRIPTION: 'B',
    HOURS_OF_OPERATION: 'C',
    OUTBOUND_CALLER_ID_NAME: 'D',
    OUTBOUND_CALLER_ID_NUMBER: 'E',
    OUTBOUND_WHISPER_FLOW_ID: 'F',
    MAX_CONTACTS: 'G'
  },
  QUICK_CONNECTS: {
    NAME: 'A',
    DESCRIPTION: 'B',
    TYPE: 'C',
    DESTINATION: 'D',
    CONTACT_FLOW_NAME: 'E'
  },
  ROUTING_PROFILES: {
    NAME: 'A',
    DESCRIPTION: 'B',
    CHANNELS: 'C',
    CHAT_CONCURRENCY: 'D',
    TASK_CONCURRENCY: 'E',
    EMAIL_CONCURRENCY: 'F',
    DEFAULT_OUTBOUND_QUEUE: 'G',
    ASSOCIATED_QUEUES: 'H',
  },
  USER_HIERARCHY_DATA: {
    LEVEL_ONE: 'A',
    LEVEL_TWO: 'B',
    LEVEL_THREE: 'C',
    LEVEL_FOUR: 'D',
    LEVEL_FIVE: 'E'
  },
  USERS: {
    FIRST_NAME: 'A',
    LAST_NAME: 'B',
    EMAIL_ADDRESS: 'C',
    USER_LOGIN: 'E',
    ROUTING_PROFILE: 'F',
    SECURITY_PROFILE: 'G',
    PHONE_TYPE: 'H',
    PHONE_NUMBER: 'I',
    SOFT_PHONE_AUTO_ACCEPT: 'J',
    ACW_TIMEOUT: 'K',
    LEVEL_1: 'L',
    LEVEL_2: 'M',
    LEVEL_3: 'N',
    LEVEL_4: 'O',
    LEVEL_5: 'P'
  },
  SECURITY_PROFILES: {
    UI_NAME: 'A',
    API_NAME: 'B',
    USE: 'C',
    ADMIN: 'D',
    AGENT: 'E',
    QUALITY_ANALYST: 'F',
    CALL_CENTER_MANAGER: 'G',
    ADDITIONAL_PROFILES_START: 'H'
  },
  LAMBDA_FUNCTIONS: {
    FUNCTION_NAME: 'A',
    DESCRIPTION: 'B',
    RUNTIME: 'C',
    LAST_MODIFIED: 'D',
    LOG_RETENTION: 'E',
    LAST_INVOCATION: 'F',
    BLOCK_FUNCTION_CREATE: 'G',
    BLOCK_FUNCTION_UPDATE: 'H',
    INVOCATIONS_30_DAYS: 'I',
    ERRORS_30_DAYS: 'J'
  },
  LEX_BOTS_V2: {
    BOT_NAME: 'A',
    DESCRIPTION: 'B',
    SUBJECT_TO_COPPA: 'C',
    IDLE_SESSION_TIMEOUT: 'D',
    LANGUAGES: 'E',
    ALIAS_VERSION: 'F',
    ASSOCIATED_TO_CONNECT: 'G',
    INTENT_COUNT: 'H',
    SLOT_TYPE_COUNT: 'I',
    LEX_VERSION: 'J',
    CONVERSATION_METRICS: 'K',
    UTTERANCE_METRICS: 'L',
    ASSOCIATED_FLOWS: 'M'
  },
  LEX_INTENTS: {
    BOT_NAME: 'A',
    LOCALE_ID: 'B',
    INTENT_NAME: 'C',
    DESCRIPTION: 'D',
    SAMPLE_UTTERANCES: 'E',
    CONFIRMATION_SETTING: 'F',
    SLOT_COUNT: 'G',
    FULFILLMENT_TYPE: 'H',
    PARENT_INTENT_SIGNATURE: 'I'
  },
  LEX_SLOTS_AND_TYPES: {
    BOT_NAME: 'A',
    LOCALE_ID: 'B',
    INTENT_NAME: 'C',
    SLOT_NAME: 'D',
    SLOT_DESCRIPTION: 'E',
    SLOT_TYPE_ID: 'F',
    SLOT_TYPE_NAME: 'G',
    SLOT_TYPE_DESCRIPTION: 'H',
    SLOT_TYPE_VALUES: 'I',
    VALUE_SELECTION_STRATEGY: 'J',
    VALUE_ELICITATION_SETTING: 'K',
    REQUIRED: 'L',
    PARENT_SLOT_TYPE_SIGNATURE: 'M',
    EXTERNAL_SOURCE_SETTING: 'N'
  },
  CONNECT_LAMBDA: {
    FUNCTION_NAME: 'A',
    DESCRIPTION: 'B',
    ASSOCIATED_FLOWS: 'C'
  },
  CONTACT_FLOWS: {
    NAME: 'A',
    STATE: 'B',
    STATUS: 'C',
    TYPE: 'D',
    IS_DEFAULT: 'E',
    CONTACT_FLOW_ERRORS: 'F'
  },
  INSTANCE_CONFIG: {
    NAME: 'A',
    VALUE: 'B'
  },
  TRUSTED_ADVISOR: {
    RECOMMENDATION_NAME: 'A',
    CATEGORY: 'B',
    STATUS: 'C',
    POTENTIAL_MONTHLY_SAVINGS: 'D',
    RESOURCES_FLAGGED: 'E',
    RESOURCES_IGNORED: 'F',
    RESOURCES_SUPPRESSED: 'G',
    RESOURCES_PROCESSED: 'H'
  },
};

export const INSTANCE_CONFIG_FIELDS = [
  // Row 5-6: AWS Account
  { row: 5, key: 'use', label: 'Use' },
  { row: 6, key: 'accountName', label: 'Account Name' },
  
  // Row 8-26: Amazon Connect Instance
  { row: 8, key: 'instanceAlias', label: 'Instance Alias' },
  { row: 9, key: 'instanceRegion', label: 'Instance Region' },
  { row: 10, key: 'identityManagement', label: 'Identity Management' },
  { row: 11, key: 'directory', label: 'Directory' },
  { row: 12, key: 'identityProvider', label: 'Identity Provider' },
  { row: 13, key: 'administratorFirstName', label: 'Administrator FirstName' },
  { row: 14, key: 'administratorLastName', label: 'Administrator LastName' },
  { row: 15, key: 'administratorUserName', label: 'Administrator UserName' },
  { row: 16, key: 'password', label: 'Password' },
  { row: 17, key: 'accessUrl', label: 'Access URL' },
  { row: 18, key: 'ccpUrl', label: 'CCP URL' },
  { row: 19, key: 'telephonyOptions', label: 'Telephony Options' },
  { row: 20, key: 'enableOutboundCampaigns', label: 'Enable Outbound Campaigns' },
  { row: 21, key: 'enableEarlyMedia', label: 'Enable Early Media' },
  { row: 22, key: 'enableMultiPartyCalls', label: 'Enable Multi-Party Calls' },
  { row: 23, key: 'amazonPolly', label: 'Amazon Polly' },
  { row: 24, key: 'enableCustomerProfiles', label: 'Enable Customer Profiles' },
  { row: 25, key: 'enableCallRecordings', label: 'Enable Call Recordings' },
  { row: 26, key: 'enableContactLens', label: 'Enable Contact Lens' },
  
  // Row 27-42: Storage Configuration
  { row: 27, key: 'callRecordingS3Bucket', label: 'Call Recording S3 Bucket' },
  { row: 28, key: 'callRecordingPathPrefix', label: 'Call Recording Path Prefix' },
  { row: 29, key: 'callRecordingEncryption', label: 'Call Recording Encryption' },
  { row: 30, key: 'enableChatTranscripts', label: 'Enable Chat Transcripts' },
  { row: 31, key: 'chatTranscriptS3Bucket', label: 'Chat Transcript S3 Bucket' },
  { row: 32, key: 'chatTranscriptPathPrefix', label: 'Chat Transcript Path Prefix' },
  { row: 33, key: 'chatTranscriptEncryption', label: 'Chat Transcript Encryption' },
  { row: 34, key: 'enableExportedReports', label: 'Enable Exported Reports' },
  { row: 35, key: 'exportedReportS3Bucket', label: 'Exported Report S3 Bucket' },
  { row: 36, key: 'exportedReportPathPrefix', label: 'Exported Report Path Prefix' },
  { row: 37, key: 'exportedReportEncryption', label: 'Exported Report Encryption' },
  { row: 38, key: 'enableAttachmentSharing', label: 'Enable Attachment Sharing' },
  { row: 39, key: 'attachmentS3Bucket', label: 'Attachment S3 Bucket' },
  { row: 40, key: 'attachmentPathPrefix', label: 'Attachment Path Prefix' },
  { row: 41, key: 'attachmentEncryption', label: 'Attachment Encryption' },
  { row: 42, key: 'contactFlowLogGroup', label: 'Contact Flow Log Group' },
];

// Starting row for data (after headers)
export const DATA_START_ROW = {
  HOURS_OF_OPERATION: 4,
  DIALED_NUMBER_MAPPINGS: 6,
  AGENT_STATUS: 5,
  QUEUES: 4,
  QUICK_CONNECTS: 4,
  ROUTING_PROFILES: 6,
  USER_HIERARCHY_DATA: 6,
  USERS: 5,
  SECURITY_PROFILES: 7,
  LAMBDA_FUNCTIONS: 4,
  LEX_BOTS_V2: 4,
  LEX_INTENTS: 4,
  LEX_SLOTS_AND_TYPES: 4,
  CONNECT_LAMBDA: 4,
  CONTACT_FLOWS: 4,
  TRUSTED_ADVISOR: 4,
};

export const HIERARCHY_STRUCTURE_ROW = 5;

// Default security profile order for fixed columns
export const DEFAULT_SECURITY_PROFILES = ['Admin', 'Agent', 'QualityAnalyst', 'CallCenterManager'];

// Column letters helper function
export const getColumnLetter = (columnIndex) => {
  let result = '';
  while (columnIndex > 0) {
    const remainder = (columnIndex - 1) % 26;
    result = String.fromCharCode(65 + remainder) + result;
    columnIndex = Math.floor((columnIndex - 1) / 26);
  }
  return result;
};